import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import { getColor } from '../system';
import Icon from '../Icon';
import Badge from './Badge';
var statuses = {
  error: {
    color: 'error',
    icon: 'close'
  },
  success: {
    color: 'success',
    icon: 'checkmark'
  }
};

/**
 * Used to show a reaction to saving user data
 */
var Status = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Status, _Component);

  function Status() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "timeout", null);

    return _this;
  }

  var _proto = Status.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.requestClear();
  };

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.status !== this.props.status) {
      this.requestClear();
    }
  };

  _proto.requestClear = function requestClear() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(this.props.onClearRequest, 1800);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        status = _this$props.status,
        light = _this$props.light,
        onClearRequest = _this$props.onClearRequest,
        props = _objectWithoutPropertiesLoose(_this$props, ["status", "light", "onClearRequest"]);

    if (!status) {
      return null;
    } else {
      var _statuses$status = statuses[status],
          color = _statuses$status.color,
          icon = _statuses$status.icon;
      return /*#__PURE__*/React.createElement(Badge, _extends({
        paddingRight: 1,
        radius: "pill",
        renderLeft: /*#__PURE__*/React.createElement(Icon, {
          name: icon
        }),
        color: light ? {
          background: 'light',
          foreground: getColor(color)
        } : getColor(color),
        fontWeight: 600
      }, props));
    }
  };

  return Status;
}(Component);

_defineProperty(Status, "defaultProps", {
  title: '',
  size: 'sm'
});

Status.displayName = 'Badge.Status';
export default Status;